import { moneyFormat } from '@/utils/util'
import NP from 'number-precision'
// import { getParentAccountId, getAccountId } from '@/directives/permission'
const dayjs = require('dayjs')
// const xiaomiId = '2576247038583552'

// 百分比显示
const filterRate = (rate) => {
  if (rate !== null && rate !== undefined) {
    return NP.times(rate, 100) + '%'
  }
  return ''
}
export const toFixed1  = (num) => {
  num = num + ''
  // 截一位小数点
  if (num.includes('.')) {
    let arr = num.split('.')
    if (arr[1].length > 1) {
      num = arr[0] + '.' + arr[1].substring(0, 1)
    }
  }
  if (num) {
    num = parseFloat(num)
  }
  return num
}

export const amountFixed1 = (amount = '') => {
  let arr = (amount + '').split('.')
  if (arr[1]) {
    amount = arr[0] + '.' + arr[1].substring(0, 1)
  }
  return amount
}

// 平台
export const typeMap = {
  douyinOMS: '抖音特惠',
  kuaishouOMS: '快手特惠',
  aikucun: '品牌优选',
  douyinLife: '抖音本地生活',
  douyinM2s: '抖音',
  douyinHP: '抖音直达',
  pdd: '拼多多',
  jd: '京东',
  taobao: '淘宝',
  kuaishou: '快手',
  // 专属商品
  douyinAPI: '抖音'
} 

// 佣金比例描述类型
export const rebateInfoTypes = {
  SPECIFIC_GOOD: '指定商品补贴',
  // SPECIFIC_QD: '指定渠道补贴',
  // ALL_GOOD: '全商品补贴',
  ALL_QD: '全渠道补贴',
  SPECIFIC_GOOD_QD: '指定商品+指定渠道',
  SPECIFIC_QD: '指定商品+全部渠道',
  ALL_GOOD: '全部商品+指定渠道'
}

export const filterReportStatus = (status) => {
  if (status === 0) {
    return '查询中'
  } else if (status == 1) {
    return '已跟单'
  } else if (status == 2) {
    return '已丢单'
  } else if (status == 3) {
    return '已返款'
  }
  
  return ''
}
export const moneyFormatFn = (amount, round) => {
  if (round === 1 && amount) {
    amount = toFixed1(amount)
  }
  return amount ? moneyFormat(amount, '') : amount
}
const orderStatusMap = {
  paid: '已支付',
  harvest: '确认收货',
  auditSuccess: '审核通过',
  fail: '已失效',
  settled: '已完成'
}
export const getOrderStatus = (status) => {
  return orderStatusMap[status] || ''
}
const filterIncomeStatus = (status) => {
  // 1-已返 0-未返
  return ['未返', '已返'][status] || ''
}
// 计算佣金比
export const computedPromotionRate = (row, round) => {
  if (row.promotionAmount && row.orderAmount) {
    let amount = NP.times(NP.divide(row.promotionAmount, row.orderAmount), 100)
    // 截断，显示一位
    if (round === 1) {
      return toFixed1(amount) + '%'
    }
    return NP.round(amount, 2) + '%'
  }
  return ''
}
export const computedPromotionRateValue = (row) => {
  if (row.promotionAmount && row.orderAmount) {
    return NP.round(NP.times(NP.divide(row.promotionAmount, row.orderAmount), 100), 2)
  }
  return ''
}

export const getFields = (roleType) => {
  return [
  {
    label: '订单编号',
    key: 'thirdOrderSn',
    type: 'number'
  },
  {
    label: '订单状态',
    key: 'orderStatus',
    format: (row) => {
      return getOrderStatus(row.orderStatus)
    }
  }, {
    label: '商品ID',
    type: 'number',
    key: 'realGoodsId'
  }, {
    label: '第三方平台',
    key: 'type',
    format: (row) => {
      return typeMap[row.type] || ''
    }
  }, {
    label: '商品主图',
    key: 'goodsThumbnailUrl'
  }, {
    label: '商品名称',
    key: 'goodsName'
  }, {
    label: '小程序链接',
    key: 'wechatMiniAppLink'
  }, {
    label: '商品金额',
    key: 'orderAmount',
    format: (row) => {
      return moneyFormatFn(row.orderAmount)
    }
  },
  // {
  //   label: '基础佣金比例',
  //   key: 'basePromotionRate',
  //   format: (row) => {
  //     return filterRate(row.basePromotionRate)
  //   },
  //   needExport: (roleType) => {
  //     return roleType != 4 // 下游账号不导出
  //   }
  // },
  // {
  //   label: '补贴佣金比例',
  //   key: 'btPromotionRate',
  //   format: (row) => {
  //     return filterRate(row.btPromotionRate)
  //   },
  //   needExport: (roleType) => {
  //     return roleType != 4 // 下游账号不导出
  //   }
  // },
  {
    label: '结算佣金比例',
    key: 'settlePromotionRate',
    format: (row) => {
      return filterRate(row.settlePromotionRate)
    },
    needExport: (roleType) => {
      return roleType != 4 // 下游账号不导出
    }
  },
  // {
  //   label: '基础佣金金额',
  //   key: 'basePromotionAmount',
  //   needExport: (roleType) => {
  //     return roleType != 4 // 下游账号不导出
  //   }
  // },
  // {
  //   label: '补贴佣金金额',
  //   key: 'btPromotionAmount',
  //   needExport: (roleType) => {
  //     return roleType != 4 // 下游账号不导出
  //   }
  // },
  {
    label: '结算佣金金额',
    key: 'settlePromotionAmount',
    needExport: (roleType) => {
      return roleType != 4 // 下游账号不导出
    }
  },
  {
    label: '下游结算佣金比例',
    key: 'downSettlePromotionRate',
    format: (row) => {
      return filterRate(row.downSettlePromotionRate)
    }
  },
  {
    label: '下游结算佣金金额',
    key: 'downSettlePromotionAmount',
  },
  {
    label: '报单时间',
    key: 'reportTime',
    format: (row) => {
      if (row.reportTime) {
        return dayjs(row.reportTime).format('YYYY-MM-DD HH:mm:ss')
      }
      return ''
    }
  },
  {
    label: '付款时间',
    key: 'orderPayTime',
    format: (row) => {
      if (row.orderPayTime) {
        return dayjs(row.orderPayTime).format('YYYY-MM-DD HH:mm:ss')
      }
      return ''
    }
  },
  {
    label: '收货时间',
    key: 'orderReceiveTime',
    format: (row) => {
      if (row.orderReceiveTime) {
        return dayjs(row.orderReceiveTime).format('YYYY-MM-DD HH:mm:ss')
      }
      return ''
    }
  },
  {
    label: '报单状态',
    key: 'qdReportStatus',
    format: (row) => {
      if (roleType === 1) {
        return filterReportStatus(row.qdReportStatus)
      } else if (roleType === 3) {
        return filterReportStatus(row.qdSubReportStatus)
      } else {
        return filterReportStatus(row.clientReportStatus)
      }
    }
  },
  {
    label: '报单入口',
    key: 'reportSource'
  },
  {
    label: '报单用户',
    key: 'reportAccountName'
  },
  {
    label: '归属渠道',
    tip: '下游渠道显示',
    key: 'parentQdAccountName',
    format: (row) => {
      if (row.qdAccountName) {
        return row.qdAccountName
      } else if (row.parentQdAccountName) {
        return row.parentQdAccountName
      }
      return ''
    },
    needExport: (roleType) => {
      return roleType === 4 // 下游账号不导出
    }
  },
  // 下游账号
  {
    label: '归属下游',
    tip: '下游渠道显示',
    key: 'downAccountName',
    needExport: (roleType) => {
      return roleType === 4
    }
  },
  {
    label: '归属渠道',
    key: 'parentQdAccountName',
    needExport: (roleType) => {
      return roleType !== 4 // 下游账号不导出
    }
  },
  {
    label: '归属二级渠道',
    key: 'qdAccountName',
    needExport: (roleType) => {
      return roleType !== 4 // 下游账号不导出
    }
  },
  {
    label: '归属下游',
    key: 'downAccountName',
    needExport: (roleType) => {
      return roleType !== 4 // 下游账号不导出
    }
  },
  {
    label: '商务标签',
    key: 'parentQdTagLabels',
    format: (row) => {
      if (row.parentQdTagLabels && row.parentQdTagLabels.length) {
        return row.parentQdTagLabels.join(',')
      }
      return ''
    }
  },
  {
    label: '风险标记',
    key: 'riskType'
  },
  {
    label: '备注',
    key: 'qdRemark'
  },
  // {
  //   label: '佣金状态',
  //   key: 'commissionValidStatus'
  // },
  // {
  //   label: '收入佣金',
  //   key: 'qdCommissionIncomeStatus',
  //   format: (row) => {
  //     if (roleType === 3) {
  //       return filterIncomeStatus(row.qdCommissionIncomeStatus)
  //     }
  //     if (roleType === 2) {
  //       return filterIncomeStatus(row.qdSubReportStatus)
  //     }
  //     if (roleType === 4) {
  //       return filterIncomeStatus(row.qdSubReportStatus)
  //     }
  //     return ''
  //   }
  // },
  // {
  //   label: '用户返利',
  //   key: 'commissionAmount',
  //   format: (row) => {
  //     return row.commissionAmount ? moneyFormat(row.commissionAmount, '') : ''
  //   }
  // },
  // {
  //   label: '佣金无效原因',
  //   key: 'commissionValidReason'
  // }
]
}

// 专属商品字段
export const getZsFields = (roleType) => {
  return [
  {
    label: '订单编号',
    key: 'thirdOrderSn',
    type: 'number'
  },
  {
    label: '订单状态',
    key: 'orderStatus',
    format: (row) => {
      return getOrderStatus(row.orderStatus)
    }
  }, {
    label: '商品ID',
    type: 'number',
    key: 'realGoodsId'
  }, {
    label: '第三方平台',
    key: 'type',
    format: (row) => {
      return typeMap[row.type] || ''
    }
  }, {
    label: '商品主图',
    key: 'goodsThumbnailUrl'
  }, {
    label: '商品名称',
    key: 'goodsName'
  }, {
    label: '小程序链接',
    key: 'wechatMiniAppLink'
  }, {
    label: '商品金额',
    key: 'orderAmount',
    format: (row) => {
      return moneyFormatFn(row.orderAmount)
    }
  }, {
    label: '佣金比例',
    key: 'settlePromotionRate',
    format: (row) => {
      return filterRate(row.settlePromotionRate)
    }
  },
  {
    label: '佣金金额',
    key: 'promotionAmount',
    format: (row) => {      
      return row.promotionAmount ? moneyFormat(row.promotionAmount, '') : ''
    }
  },
  {
    label: '报单时间',
    key: 'reportTime',
    format: (row) => {
      if (row.reportTime) {
        return dayjs(row.reportTime).format('YYYY-MM-DD hh:mm:ss')
      }
      return ''
    }
  },
  {
    label: '付款时间',
    key: 'orderPayTime',
    format: (row) => {
      if (row.orderPayTime) {
        return dayjs(row.orderPayTime).format('YYYY-MM-DD HH:mm:ss')
      }
      return ''
    }
  },
  {
    label: '收货时间',
    key: 'orderReceiveTime',
    format: (row) => {
      if (row.orderReceiveTime) {
        return dayjs(row.orderReceiveTime).format('YYYY-MM-DD HH:mm:ss')
      }
      return ''
    }
  },
  {
    label: '报单状态',
    key: 'qdReportStatus',
    format: (row) => {
      if (roleType === 1) {
        return filterReportStatus(row.qdReportStatus)
      } else if (roleType === 3) {
        return filterReportStatus(row.qdSubReportStatus)
      } else {
        return filterReportStatus(row.clientReportStatus)
      }
    }
  },
  {
    label: '报单入口',
    key: 'reportSource'
  },
  {
    label: '报单用户',
    key: 'reportAccountName'
  },

  {
    label: '归属渠道',
    key: 'parentQdAccountName'
  },
  {
    label: '归属二级渠道',
    key: 'qdAccountName'
  }]
}
